import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import moment from 'moment'

class ListItems extends Component {
  getColumns = () => {
    return [
      {
        title: 'ID',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace('/', '-')}/drawings`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Type',
        width: 300,
        dataIndex: 'type'
      },
      {
        title: 'Filename',
        width: 200,
        dataIndex: 'filename'
      },
      {
        title: 'Description',
        width: 300,
        dataIndex: 'description'
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Status Date',
        dataIndex: 'status_date',
        width: 100
      }
    ]
  }

  getData = drawings => {
    return drawings.map((item, index) => {
      item.status_date = moment(new Date(item.created_date)).format('YYYY-MM-DD')
      item.key = item.id + '_' + item.file_id
      item.job = {
        job_id: item.job_id,
        job_type: item.job_type,
        id: item.id
      }
      return item
    })
  }

  getJobList = () => {
    const { fullReport } = this.props
    let jobList = []

    fullReport.forEach(item => {
      jobList.push(
        <div>
          <h6 className="steps">{item.job_name}</h6>
          <h8>Drawings</h8>
          <Table
            pagination={false}
            columns={this.getColumns()}
            dataSource={this.getData(item.drawings)}
            size="small"
            style={{ backgroundColor: 'white' }}
          />
        </div>
      )
    })
    return jobList
  }

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <div>
              <div style={{ marginTop: 20 }} className="row">
                <div className="col-12">
                  <h5>Jobs</h5>
                  {this.getJobList()}
                </div>
              </div>
            </div>
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/jobs/drawings/ListItem.js